import { PriceModel } from '@modules/price/price-model';

const { fields } = PriceModel;

export default [
  fields.currency,
  fields.amount,
];
